import Vue from 'vue'
import VueRouter from 'vue-router'

import Auth from '@/views/Auth.vue'
import General from '@/components/General.vue'
import Start from '@/components/Start.vue'
import Login from '@/components/Login.vue'
import Register from '@/components/Register.vue'
import Verification from '@/components/Verification.vue'
import Forgot from '@/components/Forgot.vue'
import ForgotMessage from '@/components/ForgotMessage.vue'
import Welcome from '@/components/Welcome.vue'

import Main from '@/views/Main.vue'
import Home from '@/views/Home.vue'
import Emergency from '@/views/Emergency.vue'
import Room from '@/views/Room.vue'
import HowItWorks from '@/views/HowItWorks.vue'
import FAQ from '@/views/FAQ.vue'
import Terms from '@/views/Terms.vue'
import Info from '@/views/Info.vue'
import Profile from '@/views/Profile.vue'
import EditProfile from '@/views/EditProfile.vue'

import Survey from '@/views/Survey.vue'

import store from '../store/index'
Vue.use(VueRouter)

const notLogged = (to, from, next) => {
  if (!store.getters.isAuth) {
    next('/start')
  } else {
    next()
  }
}

const logged = (to, from, next) => {
  if (store.getters.isAuth) {
    next('/home')
  } else {
    next()
  }
}

const routes = [
  {
    path: '/',
    name: 'auth',
    component: Auth,
    children: [
      {
        path: '',
        name: 'general',
        component: General,
        beforeEnter: logged
      },
      {
        path: '/start',
        name: 'start',
        component: Start,
        beforeEnter: logged
      },
      {
        path: '/register',
        name: 'register',
        component: Register,
        beforeEnter: logged
      },
      {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: logged
      },
      {
        path: '/register/verification',
        name: 'registerVerification',
        component: Verification
      },
      {
        path: '/forgot-password',
        name: 'forgotPassword',
        component: Forgot,
        beforeEnter: logged
      },
      {
        path: '/forgot-message',
        name: 'forgotMessage',
        component: ForgotMessage,
        beforeEnter: logged
      },
      {
        path: '/welcome',
        name: 'welcome',
        component: Welcome,
        beforeEnter: logged
      }
    ]
  },

  {
    path: '/',
    name: 'main',
    component: Main,
    beforeEnter: notLogged,
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home
      },
      {
        path: 'emergency/:type/:doctorType?',
        name: 'emergency',
        component: Emergency,
        beforeEnter: (to, from, next) => {
          console.log(to)
          if (localStorage.getItem('mobile') &&
            ((localStorage.getItem('os') === 'ios' && localStorage.getItem('browser') === 'chrome') ||
              (localStorage.getItem('os') === 'ios' && localStorage.getItem('browser') === 'firefox') ||
              localStorage.getItem('os') === 'android' && localStorage.getItem('browser') === 'xiaomi/miuibrowser')) {
            next('/home')
          } else {
            next()
          }
        }
      },
      {
        path: 'room',
        name: 'room',
        component: Room
      },
      {
        path: 'how-it-works',
        name: 'howItWorks',
        component: HowItWorks
      },
      {
        path: 'profile',
        name: 'profile',
        component: Profile
      },
      {
        path: 'edit-profile',
        name: 'editProfile',
        component: EditProfile
      },
      {
        path: 'faq',
        name: 'faq',
        component: FAQ
      },
      {
        path: 'terms',
        name: 'terms',
        component: Terms
      },
      {
        path: 'info',
        name: 'info',
        component: Info
      },

      {
        path: 'survey',
        name: 'survey',
        component: Survey
      }
    ]
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  document.title = 'DN2Me'
  next()
})

export default router
